import React from "react";
import DataManagementTemplate from "../../../components/templates/DataManagementTemplate";
import { UserBusinessViewModel } from "../../../viewmodels/setup/userBusiness/UserBusinessViewModel";
import { useEffect } from "react";
export default function UserBusinesses() {
  const {
    columns,
    businesses,
    loading,
    pagination,
    onSearch,
    onPageChange,
    headerButtons,
    emptyMessage,
    fetchBusinesses
  } = UserBusinessViewModel();

    useEffect(() => {
    fetchBusinesses(pagination.page, "");
    // eslint-disable-next-line
  }, []);

  return (
    <DataManagementTemplate
      title="User Businesses"
      description="Manage all user business entities."
      columns={columns}
      cardContent
      data={businesses}
      headerButtons={headerButtons}
      loading={loading}
      pagination={pagination}
      onSearch={onSearch}
      onPageChange={onPageChange}
      emptyMessage={emptyMessage}
    />
  );
}
